import { render, staticRenderFns } from "./teachlist.vue?vue&type=template&id=5dc9a2f9&scoped=true"
import script from "./teachlist.vue?vue&type=script&lang=js"
export * from "./teachlist.vue?vue&type=script&lang=js"
import style0 from "./teachlist.vue?vue&type=style&index=0&id=5dc9a2f9&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc9a2f9",
  null
  
)

export default component.exports